// extracted by mini-css-extract-plugin
export default {"Heading":"Heading_Heading__YmI4M","Heading__terminalAndGate":"Heading_Heading__terminalAndGate__NzkyM"};